jQuery(document).ready(function($){
    $(".nf-result-slider").each(function () {
        var slider = $(this);
        let parentdiv = slider.parent();
        var prevbut = slider.parent().find('.nf-result-slider-prev');
        var nextbut = slider.parent().find('.nf-result-slider-next');

        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            prevArrow: prevbut,
            nextArrow: nextbut,
            dots: false,
        });
    });

    /*$(".nf-service-slider-inner").each(function () {
        var slider = $(this);
        let parentdiv = slider.parent();
        var prevbut = slider.parent().find('.nf-service-slider-prev');
        var nextbut = slider.parent().find('.nf-service-slider-next');

        slider.slick({
            slidesToScroll: 1,
            slidesToShow: 1,
            arrows: true,
            prevArrow: prevbut,
            nextArrow: nextbut,
            dots: false,
            startingSlide: 0,
        });
    });*/

    $('.standard-hero__member__slider__inner').slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        arrows: true,
        prevArrow: $('.member-prev-btn'),
        nextArrow: $('.member-next-btn'),
        dots: false,
        startingSlide: 0,
    });

    $('.standard-hero__member__slider__nav__inner').slick({
        slidesToScroll: 1,
        slidesToShow: 5,
        dots: false,
        startingSlide: 0,
        prevArrow: $('.member-prev-btn'),
        nextArrow: $('.member-next-btn'),
        focusOnSelect: true,
        asNavFor: '.standard-hero__member__slider__inner',
    });

    var $slider = $('.progress_slider');
    var $progressBar = $('.progress');
    var $progressBarLabel = $( '.slider__label' );
    var $curSlideLabel = $('.slider__label__current');
    var $totalSlideLabel = $('.slider__label__total');
    
    $slider.on('reInit', function(slick) {
        $totalSlideLabel.text( slick.slideCount );
    });
    
    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {   
      $totalSlideLabel.text( slick.slideCount );
      var calc = ( (nextSlide + 1) / (slick.slideCount) ) * 100;
      
      $progressBar
        .css('background-size', calc + '% 100%')
        .attr('aria-valuenow', calc );
      
      $progressBarLabel.text( calc + '% completed' );
      $curSlideLabel.text( nextSlide + 1);
     
    });
      
});